
  import ScreenSize from '@/mixins/ScreenSize';
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    name: 'SectionActivitySheet',
    components: {
      CustomSheet: () => import('@/components/CustomSheet'),
      CustomCompactSheet: () => import('@/components/CustomCompactSheet'),
    },
    mixins: [ScreenSize],
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
      loggedIn: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    serverCacheKey: function (props) {
      return (
        'section-activity-sheet-' +
        props.section.id +
        '-' +
        (props.section.route_name
          ? props.section.route_name
          : 'landingpages-activities-activity')
      );
    },
    data() {
      return {
        sheetElements: [],
      };
    },
    created() {
      // prepare carousel items
      if (this.section.activities) {
        this.section.activities.forEach((activity) => {
          if (
            this.section.appearance &&
            ((this.section.appearance === 'large' &&
              activity.card_image !== null) ||
              this.section.appearance === 'compact')
          ) {
            // differ target link for routing
            const params = {};
            const route_name = this.section.route_name
              ? this.section.route_name
              : 'landingpages-activities-activity';
            params.activity = activity.slug;

            if (this.section.city) {
              params.city = this.section.city.slug;
            }

            const route = {
              name: route_name,
              params: params,
            };

            let link_title = '';
            if (this.section.link_title) {
              link_title = this.section.link_title.replace(
                /%activity_name/g,
                activity.name
              );
            }

            this.sheetElements.push({
              text: activity.title,
              image: prepareImageUrl(activity.card_image.url),
              link: this.localePath(route),
              link_title: link_title,
            });
          }
        });
      }
    },
  };
